import { render, staticRenderFns } from "./MedicineDetail.vue?vue&type=template&id=45e222c0&scoped=true"
import script from "./MedicineDetail.vue?vue&type=script&lang=js"
export * from "./MedicineDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicineDetail.vue?vue&type=style&index=0&id=45e222c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e222c0",
  null
  
)

export default component.exports